export default __webpack_public_path__ + "static/media/folder-tender.16c67ab7.svg";